<div
  fxLayout="row wrap"
  fxLayout.lt-md="column center"
  fxLayoutAlign.gt-sm="space-between center"
  fxLayoutAlign.lt-md="space-between stretch"
>
  <mat-card
    [routerLink]="url(recommendation)"
    class="myCard"
    fxFlex="350px"
    fxFlex.lt-lg="300px"
    fxFlex.lt-md="100%"
    *ngFor="let recommendation of recommendations"
  >
    <mat-card-content fxLayout="column nowrap" fxLayoutAlign="left right">
      <p>{{ recommendation.vendor }}</p>
      <span class="productName">{{ recommendation.name }}</span>
      <div fxLayout="row" class="prices">
        <div align="left" fxFlex="50%" fxLayout="column">
          <div *ngIf="!(isReseller | async); else offerResellerAdvantage">
            <div *ngIf="recommendation.vendor_price > 0">
              <div class="price-label">
                <span translate="product_related_item.before"></span>
              </div>
              <div class="offer-section">
                <p>
                  {{ recommendation.vendor_price - recommendation.price |
                  pricify }}
                </p>
              </div>
            </div>
          </div>
          <ng-template #offerResellerAdvantage>
            <div *ngIf="recommendation.discount > 0">
              <div class="price-label">
                <span translate="product_related_item.before"></span>
              </div>
              <div class="offer-section">
                <p>
                  {{ (recommendation.price * recommendation.discount) / 100 |
                  pricify }}
                </p>
              </div>
            </div>
          </ng-template>
        </div>

        <div align="right" fxFlex="50%" fxLayout="column">
          <div *ngIf="!(isReseller | async); else yourResellerPrice">
            <div class="price-label">
              <span>{{ 'product_related_item.offer' | translate }}</span>
            </div>
            <div class="before-section">
              <p>{{ recommendation.price | pricify }}</p>
            </div>
          </div>
          <ng-template #yourResellerPrice>
            <div class="price-label">
              <span>{{ 'product_related_item.offer' | translate }}</span>
            </div>
            <div class="before-section">
              <p>
                {{ recommendation.price - (recommendation.price *
                recommendation.discount) / 100 | pricify }}
              </p>
            </div>
          </ng-template>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div class="priceHint" align="right" [ngClass]="{'white_bg': white_bg}">
  <p *ngIf="!(isReseller | async); else resellerPriceHint">
    {{ 'product_related_item.your_price_hint' | translate }}
  </p>
  <ng-template #resellerPriceHint>
    <p>{{ 'product_related_item.your_price_hint_reseller' | translate }}</p>
  </ng-template>
</div>
